import React from 'react';
// import { Link } from 'react-router-dom';
import { Button, HStack } from "@chakra-ui/react"


function HomePage() {
  return (
    <div style={{ margin: "2rem" }}>
      <h1>Welcome to the BLAST Search App</h1>
      <p>
        This is the homepage. Click below to perform a BLAST search.
      </p>
      <HStack>
        <Button as="a" href="/search">Go to BLAST Search</Button>
        <Button as="a" href="/search_results">Go to Search Results</Button>
      </HStack>
    </div>
  );
}

export default HomePage;
